
const page404 = document.querySelector('.page-404');
if (page404) {
    document.body.classList.add('hide-overlay');
}
